import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  incomingRepository,
  type FinancialTransactionWithIdAndTerreiroId,
} from "../repositories/incoming.repository";
import { invalidateAccountBalanceQueries } from "./invalidateAccountBalanceQueries";
import { invalidateFinancialListQueries } from "./invalidateFinancialListQueries";

/**
 * Mutation hook to edit an incoming transaction (entrada).
 * Invalidates relevant financial queries on settle.
 */
export function useEditIncomeMutation(id: string) {
  const qc = useQueryClient();

  return useMutation<unknown, Error, FinancialTransactionWithIdAndTerreiroId>({
    mutationKey: ["incoming", id, "edit"],
    mutationFn: (payload) => incomingRepository.editIncoming(payload),
    retry: 0,
    onSettled: (_data, _error, variables) => {
      return Promise.all([
        qc.invalidateQueries({ queryKey: ["incoming", id] }),
        invalidateFinancialListQueries(
          qc,
          "income",
          variables?.terreiroId,
          variables?.mediumId,
        ),
        invalidateAccountBalanceQueries(qc, {
          terreiroId: variables?.terreiroId,
          mediumId: variables?.mediumId,
        }),
      ]);
    },
  });
}
